import * as preact from "preact";
import { $$ } from "../../Core/Common";
import { DataControl, IDataControlProps } from "../DataControl/DataControl";


export interface ISelectProps extends IDataControlProps
{
    onChange?: preact.JSX.GenericEventHandler<HTMLSelectElement>;
    items?: { Key, Value }[];
    Descriptor?: string;
}

export class Select extends DataControl<ISelectProps>
{
    public override Container: HTMLSelectElement;

    constructor(props)
    {
        super(props);
    }

    public setValue(value: string)
    {
        this.Container.value = value;
    }

    public getValue()
    {
        return parseInt($$.getSelectValue(this.Container));
    }

    public getText()
    {
        this.Container.options[this.Container.selectedIndex].innerHTML;
    }

	public focus()
	{
		$$.focus(this.Container);
	}

    public render()
    {
        return (
            <span style={{ position: "relative", display: "inline-block" }}>{this.props.Descriptor ? (<span className="inputLabel">{this.props.Descriptor}</span>) : null}
            <select
                ref={(select) => { this._registerContainer(select)}} 
                onChange={this.props.onChange }>
                {
                    this.props.items.map((item, index) =>
                    {
                        return (<option key={item.Key} value={item.Key}>{item.Value}</option>);
                    })
                }
            </select></span>);
    };
}
